export default __webpack_public_path__ + "static/media/popAd5.54e667a7.gif";